module.exports = __webpack_public_path__ + "static/media/fregadero.affcc209.svg";